import { Box, FormControl, FormLabel, Textarea } from '@mui/joy';
import React, { useState } from 'react'
import ReactQuill from 'react-quill';
import { useParams } from 'react-router-dom'

function TarifstandEmpfehlungHistory() {
    const { a } = useParams();

    const [data, setdata] = useState(JSON.parse(localStorage.getItem("addi")));
    
    return (
        <Box sx={{ height: "100vh", p: 2 }}>
            <FormControl>
                <FormLabel>Neu</FormLabel>
                <ReactQuill
                    style={{ backgroundColor: "yellow" }}
                    minRows={15}
                    value={data.show_edit_empfehlung.new}
                    placeholder="Empfehlung..."
                    variant="outlined"
                    readOnly={true}
                    modules={{ toolbar: false }}
                />
            </FormControl>
            <FormControl sx={{mt: 2}}>
                <FormLabel>Alt</FormLabel>
                <ReactQuill
                    sx={{ bgcolor: "white" }}
                    minRows={15}
                    value={data.show_edit_empfehlung.old}
                    placeholder="Empfehlung..."
                    variant="outlined"
                    readOnly={true}
                    modules={{ toolbar: false }}
                />
            </FormControl>


        </Box>
    )
}

export default TarifstandEmpfehlungHistory
